import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ReactSession } from "../../../../lib/secure_reactsession";
import { showToast } from "../../../../lib/helpers";
import { savePrototypeResultQuestion } from "../../../../services/test_result";
import GlobalQuestion from "../../global-question";

export default function PrototypeTestTaskFlowQuestions({
    test,
    result,
    moveToNextTask,
    questionType,
    timeSpent,
    prototype_test_task_question,
    task,
}) {
    const location = useLocation();
    const [isActiveQuestion, setActiveQuestion] = useState(1);
    const [totalQuestion, setTotalQuestion] = useState(0);
    const [QuestionArrayList, setQuestionArrayList] = useState([]);
    const [questionArray, setQuestionArray] = useState([]);
    const [questionLoading, setQuestionLoading] = useState(false);
    const [questionTimeSpend, setQuestionTimeSpend] = useState(0);
    const [skippedCount, setSkippedCount] = useState(0);

    useEffect(() => {
        if (!test || !prototype_test_task_question) {
            console.warn('Missing required props:', { test, prototype_test_task_question });
            return;
        }

        if (prototype_test_task_question.length) {
            try {
                const questions = prototype_test_task_question.map(item => {
                    const questionData = JSON.parse(item.questions);
                    // Ensure rating scale data is properly structured
                    if (questionData.question_type === 'ratingscale') {
                        return {
                            data: {
                                ...item,
                                scale_type: questionData.scale_type || 'Numeric',
                                scale_length: questionData.scale_length || '5 points',
                                labels: questionData.labels || []
                            },
                            questionData: questionData
                        };
                    }
                    return {
                        data: item,
                        questionData: questionData
                    };
                });
                setQuestionArrayList(questions);
                setTotalQuestion(questions.length);
            } catch (error) {
                console.error('Error parsing questions:', error);
                showToast("Error loading questions. Please try again.", "error");
            }
        } else {
            saveQuestionData([], true);
        }

        // Start timer
        const timer = setInterval(() => {
            setQuestionTimeSpend(prev => prev + 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [test, prototype_test_task_question]);

    const handleQuestionSubmit = (formData, shouldEndSurvey, jumpToQuestion) => {
        if (shouldEndSurvey) {
            saveQuestionData([...questionArray, formData], false);
            return;
        }

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        if (jumpToQuestion) {
            const jumpIndex = prototype_test_task_question.findIndex(
                q => q.id === jumpToQuestion
            );
            if (jumpIndex !== -1) {
                setActiveQuestion(jumpIndex + 1);
            }
            setQuestionArray([...questionArray, formData]);
            return;
        }

        setQuestionArray([...questionArray, formData]);

        if (isActiveQuestion < prototype_test_task_question.length) {
            setActiveQuestion(prev => prev + 1);
        } else {
            saveQuestionData([...questionArray, formData], false);
        }
    };

    const saveQuestionData = (formData, shouldNavigate) => {
        if (location.pathname.substr(1, 1) === "t") {
            let data = Object.assign({}, { questions: formData });
            data["test_id"] = result && result.test_id;
            data["result_id"] = result && result.id;
            data["question_type"] = questionType;
            data["task_id"] = task.id;
            data["guest_token"] = ReactSession.get("guest_token");
            data["time_spent"] = timeSpent;

            if (questionLoading) {
                return false;
            }

            if (!shouldNavigate) {
                setQuestionLoading(true);
            }

            savePrototypeResultQuestion(data, ReactSession.get("token")).then(
                (response) => {
                    if (!shouldNavigate) {
                        setQuestionLoading(false);
                    }
                    if (response.success) {
                        moveToNextTask();
                    } else {
                        showToast(response.message, "error");
                    }
                }
            );
        } else {
            moveToNextTask();
        }
    };

    return (
        <div className="taking-test-page-wrap">
            <div className="container">
                {QuestionArrayList && QuestionArrayList.length > 0 ? (
                    QuestionArrayList.map((items, index) => {
                        const shouldRenderQuestion = isActiveQuestion === index + 1;
                        console.debug('Rendering question:', {
                            index,
                            isActiveQuestion,
                            shouldRender: shouldRenderQuestion,
                            questionData: items
                        });
                        return (
                            <div key={index}>
                                {shouldRenderQuestion && (
                                    <GlobalQuestion
                                        test={test}
                                        question={items}
                                        currentStep={isActiveQuestion}
                                        totalSteps={QuestionArrayList.length}
                                        onNext={handleQuestionSubmit}
                                        onSkip={() => {
                                            if (items.questionData.is_optional) {
                                                handleQuestionSubmit({
                                                    type: items.questionData.questionType,
                                                    question_id: items.data.id,
                                                    answer: "",
                                                    option_id: [],
                                                    is_skipped: 1,
                                                    question_time_spent: questionTimeSpend
                                                });
                                            }
                                        }}
                                        isOptional={items.questionData.is_optional}
                                        timeSpent={timeSpent}
                                        questionType={questionType}
                                        result={result}
                                        callback={moveToNextTask}
                                        methodology="prototype"
                                        skippedCount={skippedCount}
                                        onSkipCountChange={setSkippedCount}
                                    />
                                )}
                            </div>
                        );
                    })
                ) : (
                    <div className="no-questions-message">
                        <p>No questions available for this task.</p>
                    </div>
                )}
            </div>
        </div>
    );
}